export default (theme) => {
  return {
    icon: {
      fontSize: 'inherit',
      verticalAlign: 'middle',
    },
  }
}
